import React from 'react';
import styles from './Taxonomy.scss';
import taxonomyData from '../constants/taxonomy/index';
import { CHANNEL_PROP_TYPES } from '../../../shared/model/types';
import Link from '../../../shared/components/Link';

export default class Taxonomy extends React.Component {
  static propTypes = {
    currentChannel: CHANNEL_PROP_TYPES.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      currentTabIndex: 0,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currentChannel !== nextProps.currentChannel) {
      this.setState({
        currentTabIndex: 0,
      });
    }
  }

  render() {
    const taxonomyOfCurrentChannel = taxonomyData[this.props.currentChannel.id];
    const currentTab = taxonomyOfCurrentChannel.tabs[this.state.currentTabIndex];
    const links = currentTab.links.map((link, index) => {
      const { prefix, region, uri } = link;

      return (
        <li key={`taxonomy-${prefix}-${region}-${index}`} className={styles.contentList}>
          <Link
            className={styles.link}
            href={uri}
            title={`${prefix} ${region}`}
          >
            <span>{`${prefix} `}</span>
            <span className={styles.locationText}>{region}</span>
          </Link>
        </li>
      );
    });

    return (
      <section className={styles.container}>
        <div className={styles.wrapper}>
          <h2 className={styles.title}>{taxonomyOfCurrentChannel.title}</h2>
          <div className={styles.menu}>
            {
              taxonomyOfCurrentChannel.tabs.map((table, index) => (
                <button
                  key={`taxonomy-${table.name}`}
                  className={this.state.currentTabIndex === index ? styles.activeButtonTab : styles.buttonTab}
                  onClick={() => this.setState({
                    currentTabIndex: index,
                  })}
                  type="button"
                >
                  {table.name}
                </button>
              ))
            }
          </div>
          <ul className={styles.content}>
            {links}
          </ul>
        </div>
      </section>
    );
  }
}
